import { useTranslation } from 'react-i18next';
import { ColumnDef } from '@tanstack/react-table';
import { TableCell } from '@anytag/shared-atoms';
import { formatIntNumber } from '@anytag/shared-utils';
import { usePostDetailsParam } from '@anytag/shared-hooks';
import { TwitterAnalyticsPostItemPayload, TwitterAnalyticsPostsSortOrder } from '@anytag/graphql';

export const useInfluencerTwitterPostsListTable = () => {
  const { t } = useTranslation();
  const { setPostDetailsParam } = usePostDetailsParam();

  const columns: ColumnDef<TwitterAnalyticsPostItemPayload>[] = [
    {
      accessorKey: 'post',
      meta: { sticky: true },
      header: t<string>('HeaderColumn.Posts'),
      cell: ({ row }) => (
        <TableCell.Post
          title={row.original.title || ''}
          thumbnail={row.original.thumbnail || ''}
          onClick={() => setPostDetailsParam(row.original.id)}
        />
      )
    },
    {
      accessorKey: 'likes',
      header: t<string>('HeaderColumn.Like'),
      meta: { align: 'right', sortField: TwitterAnalyticsPostsSortOrder.LIKES },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.like)} />
    },
    {
      accessorKey: 'views',
      header: t<string>('HeaderColumn.View'),
      meta: { align: 'right', sortField: TwitterAnalyticsPostsSortOrder.VIEWS },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.view)} />
    },
    {
      accessorKey: 'reply',
      header: t<string>('HeaderColumn.Reply'),
      meta: { align: 'right', sortField: TwitterAnalyticsPostsSortOrder.REPLIES },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.reply)} />
    },
    {
      accessorKey: 'retweet',
      header: t<string>('HeaderColumn.Retweet'),
      meta: { align: 'right', sortField: TwitterAnalyticsPostsSortOrder.RETWEETS },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.retweet)} />
    },
    {
      accessorKey: 'impression',
      header: t<string>('HeaderColumn.Imps'),
      meta: { align: 'right', sortField: TwitterAnalyticsPostsSortOrder.IMPRESSIONS },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.impression)} />
    },
    {
      accessorKey: 'postDate',
      header: t<string>('HeaderColumn.Post date'),
      meta: { sortField: TwitterAnalyticsPostsSortOrder.POST_DATE },
      cell: ({ row }) => <TableCell.Date className="min-w-20" value={row.original.postDate} />
    }
  ];

  return { columns };
};
